<template>
    <!-- PASO 3: Selección de Productos -->
    <div v-if="paso === 3" class="card card-navy">
        <div class="card-header">
            <h3>3. Seleccionar Productos</h3>
        </div>
        <div class="card-body">

            <div class="form-group mb-3">
                <div class="custom-control custom-switch">
                    <input type="checkbox" id="allProductsSwitch" class="custom-control-input"
                        v-model="form.all_products">
                    <label class="custom-control-label" for="allProductsSwitch">
                        Válida para todos los productos
                    </label>
                </div>
            </div>

            <table v-show="!form.all_products" id="productosStep3" class="table table-bordered table-striped mb-0"
                style="width:100%">
            </table>

        </div>
        <div class="card-footer ">
            <div class="d-flex justify-content-between">
              <button class="btn btn-danger" @click="prevStep">Atrás</button>
            <button class="btn btn-warning" @click="clearProductosSelection">
                Limpiar
            </button>
            <button class="btn btn-success" @click="nextStep">Siguiente</button>  
            </div>
            
        </div>
    </div>


</template>
<script>
import api from "@/services/api";
export default {
    data() {
        return {
            // … resto …
            paso: 3,
            productosTable: null,
            form: { all_products: false, productos: [] }
        };
    },
    async mounted() {
        await this.loadProductos();      // paso inicial: carga la tabla
    },
    methods: {
        async fetchProductos() {
            try {
                const { data } = await api.get("/producto");
                return data;
            } catch (e) {
                console.error("Error cargando productos:", e);
                return [];
            }
        },

        // 2️⃣ Inicializa o recarga DataTable con los datos
        async loadProductos() {
            const productos = await this.fetchProductos();

            // destruye si ya existe
            if (this.productosTable) {
                this.productosTable.clear().rows.add(productos).draw();
                return;
            }

            // primera vez: crea la tabla
            const vm = this;
            this.productosTable = $("#productosStep3").DataTable({
                data: productos,
                destroy: true,
                columns: [
                    {
                        title: "",
                        orderable: false,
                        data: null,
                        render(row) {
                            const checked = vm.form.productos.includes(row.id)
                                ? "checked"
                                : "";
                            return `<input type="checkbox" value="${row.id}" ${checked}>`;
                        }
                    },
                    { title: "Codigo", data: "codigo" },
                    { title: "Descripcion", data: "descripcion" }
                ],
                autoWidth: false,
                pageLength: 10,
                lengthChange: false,
                pagingType: 'numbers',
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json'
                },
                dom: // 1ª fila: filtro (f) ocupa toda la anchura en móvil y la mitad en md+
                    '<"row mb-3"<"col-12 col-md-6"f>>' +
                    // tabla
                    't' +

                    // fila 1: info centrado
                    '<"row mt-3"<"col-12 text-center"i>>' +
                    // fila 2: paginación centrada
                    '<"row"<"col-12 d-flex justify-content-center"p>>',

            });

            // checkbox listeners
            $("#productosStep3").on("change", "input[type=checkbox]", function () {
                const id = +this.value;
                if (this.checked) {
                    if (!vm.form.productos.includes(id)) vm.form.productos.push(id);
                } else {
                    vm.form.productos = vm.form.productos.filter(x => x !== id);
                }
            });
        },

        clearProductosSelection() {
            this.form.productos = [];
            if (this.productosTable) {
                this.productosTable
                    .$('input[type=checkbox]')
                    .prop("checked", false);
            }
        },
    }
};
</script>